import { render, staticRenderFns } from "./trainingModulePageStart.vue?vue&type=template&id=7e879d58&scoped=true&"
import script from "./trainingModulePageStart.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageStart.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageStart.vue?vue&type=style&index=0&id=7e879d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e879d58",
  null
  
)

export default component.exports